<div class="connector-management">
  <div class="card">
    <div class="group-header">
      <h5>Connector Groups Management</h5>
      <button class="btn btn-primary-soft flex-start" (click)="openGroupModal($event)">
        <i class="fa fa-plus color-inherit"></i> Add Connector Group
      </button>
    </div>
    <div class="card-body">
      <!-- Connector Groups Section -->
      <div class="mb-4">
        <div *ngIf="isLoadingGroups" class="text-center p-4">
          <span class="spinner-border spinner-border-sm"></span>
          <span class="ms-2">Loading connector groups...</span>
        </div>
        <div class="table-responsive" *ngIf="!isLoadingGroups">
          <table class="table table-docs table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let group of connectorGroups"
                [class.active-group]="selectedGroupId === (group.Id?.toString() || '')">
                <td>
                  <a href="javascript:void(0);" (click)="onGroupSelect(group.Id?.toString() || '')"
                    class="text-primary">
                    {{ group.Name }}
                  </a>
                </td>
                <td>{{ group.Description }}</td>
                <td class="text-center">
                  <button class="btn btn-sm btn-info" (click)="openGroupModal($event, group)" title="Edit">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-danger"
                    (click)="deleteConnectorGroup($event, group.Id?.toString() || '')" title="Delete">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="connectorGroups.length === 0">
                <td colspan="3" class="text-center">No connector groups found. Please add a connector group.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Connector Group Modal -->
<div class="popup-screen" *ngIf="showGroupModal">
  <div class="popup-container">
    <div class="popup-header">
      {{ editMode ? 'Edit' : 'Add' }} Connector Group
      <button type="button" class="close" (click)="closeGroupModal()">
        &times;
      </button>
    </div>
    <div class="popup-body">
      <form [formGroup]="connectorGroupForm">
        <div class="form-group">
          <label for="name">Name <span class="required">*</span></label>
          <input type="text" id="name" class="form-control" formControlName="name" placeholder="Enter group name">
        </div>
        <div class="form-group">
          <label for="description">Description</label>
          <textarea id="description" class="form-control" formControlName="description" rows="3"
            placeholder="Enter group description"></textarea>
        </div>
      </form>
    </div>
    <div class="button-container flex-end">
      <button type="button" class="btn btn-light-soft" (click)="closeGroupModal()">Cancel</button>
      <button type="button" class="btn btn-primary-soft" (click)="saveConnectorGroup()"
        [disabled]="connectorGroupForm.invalid || isSaving">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
        {{ editMode ? 'Update' : 'Create' }}
      </button>
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
<div class="popup-screen confirm-modal" *ngIf="showConfirmModal">
  <div class="popup-container">
    <div class="popup-header">
      {{ confirmModalData.title }}
      <button type="button" class="close" (click)="closeConfirmModal()">
        &times;
      </button>
    </div>
    <div class="popup-body">
      <p>{{ confirmModalData.message }}</p>
    </div>
    <div class="button-container flex-end">
      <button type="button" class="btn btn-light-soft" (click)="closeConfirmModal()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary-soft" (click)="confirmModalData.onConfirm()" [disabled]="isSaving">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
        {{ confirmModalData.confirmText || 'Confirm' }}
      </button>
    </div>
  </div>
</div>
